<template>
  <div class="print-preview-container">
    <div class="print-header">
      <button @click="handleBack" class="back-btn">返回</button>
      <h1>打印预览</h1>
      <button @click="handlePrint" class="print-btn">打印</button>
    </div>

    <div id="print-content" class="print-content">
      <div v-for="(item, index) in printData" :key="item.id" class="label-card">
        <table class="label-table">
          <tbody>
            <tr>
              <td class="title-left" colspan="4">备料标签</td>
              <td class="title-right">NO{{ index + 1 }}</td>
            </tr>
            <tr>
              <td class="label-cell">供应商名称</td>
              <td class="value-cell" colspan="4">
                {{ item.supplierName || "" }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">子库编码</td>
              <td class="value-cell" colspan="2">{{ item.invCode || "" }}</td>
              <td class="label-cell">送货仓库</td>
              <td class="value-cell">{{ item.factoryName || "" }}</td>
            </tr>
            <tr>
              <td class="label-cell">打印时间</td>
              <td class="value-cell">{{ printTime }}</td>
              <td class="label-cell">需求数量</td>
              <td class="value-cell quantity-cell" colspan="2">
                {{ formatNumber(getFirstMaterial(item).demandNum) }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">物料编码</td>
              <td class="value-cell material-no" colspan="4">
                {{ getFirstMaterial(item).materialNo || "" }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">物料描述</td>
              <td class="value-cell" colspan="4">
                {{ getFirstMaterial(item).materialDesc || "" }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">纸箱包装</td>
              <td class="value-cell" colspan="2">
                {{ getFirstMaterial(item).packageNum || "" }}
              </td>
              <td class="label-cell">胶装数量</td>
              <td class="value-cell"></td>
            </tr>
            <tr>
              <td class="label-cell">库位信息</td>
              <td class="value-cell" colspan="4">
                {{ getFirstPalletCode(item) || "" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "WareOutPrintPreview",
  setup() {
    const router = useRouter();
    const printData = ref([]);
    const printTime = ref("");

    const handleBack = () => {
      router.back();
    };

    const getFirstMaterial = (item) => {
      if (item.wareOutDetailList && item.wareOutDetailList.length > 0) {
        return item.wareOutDetailList[0];
      }
      return {};
    };

    const getFirstPalletCode = (item) => {
      const material = getFirstMaterial(item);
      if (material.recordList && material.recordList.length > 0) {
        return material.recordList[0].palletCode || "";
      }
      return "";
    };

    const formatNumber = (num) => {
      if (!num) return "";
      const n = parseFloat(num);
      if (isNaN(n)) return num;
      return n.toFixed(0);
    };

    const handlePrint = () => {
      // 创建打印内容
      let printHTML = `
        <style>
          @page {
            size: 100mm 70mm;
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
            width: 100mm;
            height: 70mm;
          }
          .label-table {
            width: 100mm;
            height: 70mm;
            border-collapse: collapse;
            border: 1px solid #000;
            table-layout: fixed;
          }
          .label-table td {
            border: 1px solid #000;
            padding: 2px;
            vertical-align: middle;
            font-size: 11px;
            overflow: hidden;
            line-height: 1.1;
          }
          .title-left {
            text-align: left;
            font-weight: bold;
            font-size: 14px;
            padding-left: 6px;
          }
          .title-right {
            text-align: right;
            font-weight: bold;
            font-size: 12px;
            padding-right: 6px;
          }
          .label-cell {
            width: 55px;
            font-weight: bold;
            font-size: 10px;
            padding-left: 4px;
          }
          .value-cell {
            width: auto;
            font-size: 10px;
          }
          .quantity-cell {
            font-size: 12px;
            font-weight: bold;
            text-align: right;
            padding-right: 6px;
          }
          .material-no {
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.5px;
          }
        </style>
      `;

      printData.value.forEach((item, index) => {
        printHTML += `
          <table class="label-table">
            <tbody>
              <tr>
                <td class="title-left" colspan="4">备料标签</td>
                <td class="title-right">NO${index + 1}</td>
              </tr>
              <tr>
                <td class="label-cell">供应商名称</td>
                <td class="value-cell" colspan="4">${
                  item.supplierName || ""
                }</td>
              </tr>
              <tr>
                <td class="label-cell">子库编码</td>
                <td class="value-cell" colspan="2">${item.invCode || ""}</td>
                <td class="label-cell">送货仓库</td>
                <td class="value-cell">${item.factoryName || ""}</td>
              </tr>
              <tr>
                <td class="label-cell">打印时间</td>
                <td class="value-cell">${printTime.value}</td>
                <td class="label-cell">需求数量</td>
                <td class="value-cell quantity-cell" colspan="2">${formatNumber(
                  getFirstMaterial(item).demandNum,
                )}</td>
              </tr>
              <tr>
                <td class="label-cell">物料编码</td>
                <td class="value-cell material-no" colspan="4">${
                  getFirstMaterial(item).materialNo || ""
                }</td>
              </tr>
              <tr>
                <td class="label-cell">物料描述</td>
                <td class="value-cell" colspan="4">${
                  getFirstMaterial(item).materialDesc || ""
                }</td>
              </tr>
              <tr>
                <td class="label-cell">纸箱包装</td>
                <td class="value-cell" colspan="2">${
                  getFirstMaterial(item).packageNum || ""
                }</td>
                <td class="label-cell">胶装数量</td>
                <td class="value-cell"></td>
              </tr>
              <tr>
                <td class="label-cell">库位信息</td>
                <td class="value-cell" colspan="4">${
                  getFirstPalletCode(item) || ""
                }</td>
              </tr>
            </tbody>
          </table>
          <div style="page-break-after: always;"></div>
        `;
      });

      const printWindow = window.open("", "_blank");
      printWindow.document.write(printHTML);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
      }, 250);
    };

    onMounted(() => {
      const data = sessionStorage.getItem("wareOutPrintData");
      if (data) {
        try {
          printData.value = JSON.parse(data);
        } catch (e) {
          console.error("解析打印数据失败", e);
        }
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      printTime.value = `${year}/${month}/${day} ${hour}:${minute}`;
    });

    return {
      printData,
      printTime,
      handleBack,
      handlePrint,
      getFirstMaterial,
      getFirstPalletCode,
      formatNumber,
    };
  },
};
</script>

<style scoped>
.print-preview-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.back-btn,
.print-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.back-btn {
  background-color: #f0f0f0;
}

.print-btn {
  background-color: #23b1c0;
  color: white;
}

.print-header h1 {
  margin: 0;
  font-size: 18px;
}

.print-content {
  background-color: white;
  padding: 20px;
}

.label-card {
  width: 100mm;
  height: 70mm;
  box-sizing: border-box;
  margin-bottom: 10mm;
  page-break-inside: avoid;
}

.label-table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  table-layout: fixed;
}

.label-table td {
  border: 1px solid #000;
  padding: 2px;
  vertical-align: middle;
  font-size: 11px;
  overflow: hidden;
  line-height: 1.1;
}

.title-left {
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  padding-left: 6px;
}

.title-right {
  text-align: right;
  font-weight: bold;
  font-size: 12px;
  padding-right: 6px;
}

.quantity-cell {
  font-size: 12px;
  font-weight: bold;
  text-align: right;
  padding-right: 6px;
}

.label-cell {
  width: 55px;
  font-weight: bold;
  font-size: 10px;
}

.value-cell {
  width: auto;
  font-size: 10px;
}

.material-no {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
}
</style>

<style>
@media print {
  @page {
    size: 100mm 70mm;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    width: 100mm;
    height: 70mm;
  }

  .print-preview-container {
    margin: 0;
    padding: 0;
    width: 100mm;
    height: 70mm;
  }

  .print-header {
    display: none !important;
  }

  .print-content {
    padding: 0;
    margin: 0;
    width: 100mm;
    height: 70mm;
  }

  .label-card {
    margin: 0;
    padding: 0;
    width: 100mm;
    height: 70mm;
    page-break-after: always;
  }

  .label-table {
    width: 100mm !important;
    height: 70mm !important;
    border: 1px solid #000;
  }
}
</style>
